module.exports = __webpack_public_path__ + "assets/desktop_column_view.0956d159.svg";